exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".dynamic-pricing-rule-component[data-v-07e25fbd]{flex:1}input[type=checkbox][data-v-07e25fbd],input[type=radio][data-v-07e25fbd]{margin:4px 0 0;margin-top:1px\\9;line-height:normal;box-shadow:none}input[type=number][data-v-07e25fbd]{box-shadow:none;border-radius:5px}.error[data-v-07e25fbd]{color:red}.row.align-items-end[data-v-07e25fbd]{display:flex;align-items:flex-end}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-07e25fbd&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/DynamicPricingAssignRuleToProductComponent.vue
// module id = 839
// module chunks = 2